import data from "./data";
import WplywyTable from "./table";
const WplywyBezPrzekazania = () => {
    return (
      <>
        <WplywyTable></WplywyTable>
      </>
    );
  };
  export default WplywyBezPrzekazania;